import { resolveStaffModuleAccess } from './staffModulePermissions';

/**
 * Grants de asientos (crear/editar) — sincronizar con smart_back y server_admin.
 *
 * Default-DENY para roles externos (USER_SMARTCFO); default-ALLOW para el equipo
 * interno (ADMIN/COLABORADOR/SUPER_COLABORADOR). Se resuelve SOLO a nivel usuario
 * (igual que smart_back), no a nivel empresa: el permiso se concede al usuario.
 */
export const CREAR_ASIENTO_MODULE_ID = 'crear_asiento';
export const EDITAR_ASIENTO_MODULE_ID = 'editar_asiento';

export function resolveCrearAsientoAccess(userModulePermissions, roles) {
  return resolveStaffModuleAccess(
    CREAR_ASIENTO_MODULE_ID,
    userModulePermissions,
    undefined,
    undefined,
    roles,
  );
}

export function resolveEditarAsientoAccess(userModulePermissions, roles) {
  return resolveStaffModuleAccess(
    EDITAR_ASIENTO_MODULE_ID,
    userModulePermissions,
    undefined,
    undefined,
    roles,
  );
}
